<!-- display-mobile-12 preview — a full-screen interstitial card: the ad covers
     the phone on its own, so there is no publisher page or browser bar behind
     it. The copy leads, the creative sits above a full-width action bar. -->
<app-mobile-frame>
  <!-- START: Real ad -->
  <div class="da-interstitial d-flex flex-column">
    <span class="da-adchoices d-flex align-items-center justify-content-center">
      <i class="bi bi-info-circle"></i>
    </span>

    <!-- The interstitial's own dismiss control rather than authored copy, so it
         is a plain button and not a link out to the advertiser. -->
    <span class="da-close d-flex align-items-center justify-content-center">
      <i class="bi bi-x-lg"></i>
    </span>

    <div class="da-brand d-flex flex-row align-items-end">
      <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
      <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

      <!-- GenSingleImagePreviewData carries no advertiser field, so the name is
           a literal here, the same compromise the other placements make. -->
      <span class="da-advertiser">Valamar</span>
    </div>

    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
      {{ data.headlines[0] || "Your headline appears here" }}
    </a>

    <div class="da-desc">
      {{ data.descriptions[0] || "Your description appears here" }}
    </div>

    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
      <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>
    </a>

    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta d-flex flex-row align-items-center justify-content-between">
      <span class="da-cta-label">{{ data.ctaText || "Your call to action" }}</span>
      <i class="bi bi-chevron-right"></i>
    </a>
  </div>
  <!-- END: Real ad -->
</app-mobile-frame>
